import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';

import { preto } from '../../styles/colors';
import { Col } from '../../styles/grid';
import { 
  slugEmail,
  btnTextLogin, 
  placeholderPassword,
  slugPassword,
  placeholderEmail,
 } from './constants';
import { LoadingBox } from '../_layouts/styles/common';
import { 
  FormLogin, 
  LoginBox, 
  LoginButton, 
  LoginButtonText, 
  LoginInput, 
  LoginInputBox, 
  LoginInputLabel, 
  LoginLeft, 
  LoginRight, 
  LogoImage, 
  LogoImageBox, 
  LogoLeftImage, 
  SeePasswordButton, 
  SeePasswordImage 
} from './styles';

import {
  loginAdminRequest,
  clearFields,
} from '../../store/modules/auth/actions';

export default function LoginAdmin() {
  const urlParams = new URLSearchParams(useLocation().search);
  const error = urlParams.get('erro');
  const advertiserToken = urlParams.get('t');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const loading = useSelector((state) => state.auth.loading);
    const dispatch = useDispatch();

  // Get permission to send notifications
  async function getNotificationPermission() {
    // Verify if the browser has notification functionality
    if ('Notification' in window) {
      // If user blocked the notification permission
      if (Notification.permission === 'denied') {
        toast.info(
          'Você não permitiu que a nossa plataforma envie notificações. Caso queira as notificações do navegador, ative-as.',
          {
            autoClose: 8000,
          }
        );
      } else {
        // Ask user to allow notification permissions
        Notification.requestPermission();
      }
    }
  }

  useEffect(() => {
    dispatch(clearFields());
    getNotificationPermission();
  }, [dispatch]);

  useEffect(() => {
    if (error === 'sessao-invalida') {
      toast.error('Sua sessão está inválida. Faça login novamente', {
        autoClose: false,
      });
    }
  }, [error])

  const handleSubmit = ({ email, password }) => {
    if (!advertiserToken.trim()) {
      toast.error('Token de acesso não gerado. Tente novamente pela plataforma do admin', {
        autoClose: false,
      });

      return
    }
    dispatch(loginAdminRequest(email, password, advertiserToken));
  };

  return (
    <>
      <LoginLeft>
        <LogoLeftImage
          src={require('../../assets/images/login/login@2x.png')}
        />
      </LoginLeft>
      {/* Form Login */}
      <LoginRight>
        <LogoImageBox>
          <LogoImage
            src={require('../../assets/images/logo_kuppi/logo_kuppi@2x.png')}
          />
        </LogoImageBox>
        <FormLogin onSubmit={handleSubmit}>
          <LoginInputBox>
            <Col height="auto" width="80%">
              <LoginInputLabel >{slugEmail}</LoginInputLabel>
            </Col>
            <LoginBox>
              <LoginInput
                name="email"
                type="email"
                placeholder={placeholderEmail}
              />
            </LoginBox>
          </LoginInputBox>
          <LoginInputBox margtop="10px">
            <Col height="auto" width="80%">
              <LoginInputLabel>{slugPassword}</LoginInputLabel>
            </Col>
            <LoginBox>
              <LoginInput
                name="password"
                type={passwordVisible ? 'text' : 'password'}
                placeholder={placeholderPassword}
              />
              <SeePasswordButton
                type="button"
                onClick={() => setPasswordVisible(!passwordVisible)}
              >
                <SeePasswordImage
                  src={require(passwordVisible
                    ? '../../assets/images/eye-outline/eye-outline.png'
                    : '../../assets/images/eye-outline/eye-off-outline.png')}
                />
              </SeePasswordButton>
            </LoginBox>
          </LoginInputBox>
          <LoginBox>
            <LoginButton type="submit" disabled={loading}>
              {loading ? (
                <LoadingBox>
                  <Spinner
                    style={{ width: '1.8rem', height: '1.8rem', color: preto }}
                  />
                </LoadingBox>
              ) : (
                <LoginButtonText>{btnTextLogin}</LoginButtonText>
              )}
            </LoginButton>
          </LoginBox>
        </FormLogin>
      </LoginRight>
    </>
  )
}

